module.exports = "query ($filter: DraftFilter) {\n  Drafts(filter: $filter) {\n    ...BaseDraft\n  }\n}\n\nfragment BaseDraft on Draft {\n  id\n}\n"